import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { BellIcon, SendIcon, UserIcon, UsersIcon, ArrowLeftIcon } from 'lucide-react';
import { BottomNav } from '../components/BottomNav';
interface Message {
  id: string;
  type: 'educator' | 'community';
  sender: {
    name: string;
    avatar: string;
    role?: string;
  };
  content: string;
  time: string;
  replies?: Reply[];
  isRead: boolean;
}
interface Reply {
  id: string;
  sender: string;
  content: string;
  time: string;
}
export function Notifications() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const handleBackClick = () => {
    navigate(-1);
  };
  const currentUser = {
    name: '妈妈，张春燕',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80'
  };
  const [messages, setMessages] = useState<Message[]>([{
    id: 'm1',
    type: 'educator',
    sender: {
      name: '李老师',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
      role: '资深养育师'
    },
    content: '您好！看到您最近完成了"0-6个月宝宝发展"的课程，做得很棒！有任何关于宝宝发展的问题都可以随时问我。',
    time: '2小时前',
    replies: [],
    isRead: false
  }, {
    id: 'm2',
    type: 'community',
    sender: {
      name: '王女士',
      avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80'
    },
    content: '大家好！我家宝宝6个月了，最近开始添加辅食，有什么好的建议吗？',
    time: '3小时前',
    replies: [{
      id: 'r1',
      sender: '刘女士',
      content: '我家宝宝刚开始吃米粉，建议从单一食材开始，观察3-5天没有过敏反应再添加新的。',
      time: '2小时前'
    }],
    isRead: false
  }, {
    id: 'm3',
    type: 'educator',
    sender: {
      name: '陈老师',
      avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
      role: '营养专家'
    },
    content: '本周营养小贴士：6个月宝宝添加辅食时，建议先从高铁米粉开始，每次只添加一种新食材，观察3-5天确认无过敏反应后再添加下一种。',
    time: '昨天',
    replies: [],
    isRead: false
  }]);
  const [expandedMessage, setExpandedMessage] = useState<string | null>(null);
  const [replyText, setReplyText] = useState<{
    [key: string]: string;
  }>({});
  const toggleMessage = (messageId: string) => {
    if (expandedMessage === messageId) {
      setExpandedMessage(null);
    } else {
      setExpandedMessage(messageId);
      // 标记为已读
      setMessages(messages.map(msg => msg.id === messageId ? {
        ...msg,
        isRead: true
      } : msg));
    }
  };
  const handleReply = (messageId: string) => {
    const text = replyText[messageId];
    if (text && text.trim()) {
      setMessages(messages.map(msg => {
        if (msg.id === messageId) {
          return {
            ...msg,
            replies: [...(msg.replies || []), {
              id: `r${Date.now()}`,
              sender: currentUser.name,
              content: text,
              time: '刚刚'
            }]
          };
        }
        return msg;
      }));
      setReplyText({
        ...replyText,
        [messageId]: ''
      });
    }
  };
  const educatorMessages = messages.filter(m => m.type === 'educator');
  const communityMessages = messages.filter(m => m.type === 'community');
  return <div className="min-h-screen bg-gradient-to-b from-purple-50 to-blue-50 pb-16" data-id="element-418">
      <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-419">
        <div className="px-4 py-3 flex items-center justify-center relative" data-id="element-420">
          <button onClick={handleBackClick} className={'absolute left-4 transition-colors'} data-id="element-421">
            <ArrowLeftIcon size={20} className="mb-1" data-id="element-422" />
            <span className="text-xs font-medium" data-id="element-423">返回</span>
          </button>
          <h1 className="text-2xl font-bold text-amber-700" data-id="element-424">Everseed</h1>
          <div className="flex items-center space-x-3 absolute right-4" data-id="element-425">
            <div className="relative" data-id="element-426">
              <BellIcon size={24} className="text-indigo-600" data-id="element-427" />
            </div>
            <img src={currentUser.avatar} alt={currentUser.name} className="w-9 h-9 rounded-full object-cover border-2 border-indigo-200" data-id="element-428" />
          </div>
        </div>
      </header>
      <main className="px-4 py-4" data-id="element-429">
        <div className="mb-6" data-id="element-430">
          <div className="flex items-center mb-3" data-id="element-431">
            <UserIcon size={20} className="text-indigo-600 mr-2" data-id="element-432" />
            <h2 className="text-lg font-bold text-gray-800" data-id="element-433">养育师消息</h2>
          </div>
          <div className="space-y-3" data-id="element-434">
            {educatorMessages.map(message => <div key={message.id} className={`bg-white rounded-xl shadow-md overflow-hidden ${!message.isRead ? 'border-2 border-indigo-200' : ''}`} data-id="element-435">
                <div className="p-4 cursor-pointer active:bg-gray-50" onClick={() => toggleMessage(message.id)} data-id="element-436">
                  <div className="flex items-start gap-3" data-id="element-437">
                    <img src={message.sender.avatar} alt={message.sender.name} className="w-12 h-12 rounded-full object-cover" data-id="element-438" />
                    <div className="flex-1" data-id="element-439">
                      <div className="flex items-center justify-between mb-1" data-id="element-440">
                        <div data-id="element-441">
                          <h3 className="font-semibold text-gray-800" data-id="element-442">
                            {message.sender.name}
                          </h3>
                          <p className="text-xs text-indigo-600" data-id="element-443">
                            {message.sender.role}
                          </p>
                        </div>
                        <span className="text-xs text-gray-500" data-id="element-444">
                          {message.time}
                        </span>
                      </div>
                      <p className="text-sm text-gray-700 line-clamp-2" data-id="element-445">
                        {message.content}
                      </p>
                    </div>
                  </div>
                </div>
                {expandedMessage === message.id && <div className="border-t border-gray-100 bg-gray-50 p-4" data-id="element-446">
                    <p className="text-sm text-gray-700 mb-4" data-id="element-447">
                      {message.content}
                    </p>
                    {message.replies && message.replies.length > 0 && <div className="space-y-3 mb-4" data-id="element-448">
                        {message.replies.map(reply => <div key={reply.id} className="bg-white rounded-lg p-3" data-id="element-449">
                            <div className="flex items-center justify-between mb-2" data-id="element-450">
                              <span className="text-sm font-medium text-gray-800" data-id="element-451">
                                {reply.sender}
                              </span>
                              <span className="text-xs text-gray-500" data-id="element-452">
                                {reply.time}
                              </span>
                            </div>
                            <p className="text-sm text-gray-700" data-id="element-453">
                              {reply.content}
                            </p>
                          </div>)}
                      </div>}
                    <div className="flex gap-2" data-id="element-454">
                      <input type="text" value={replyText[message.id] || ''} onChange={e => setReplyText({
                  ...replyText,
                  [message.id]: e.target.value
                })} placeholder="输入回复..." className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-455" />
                      <button onClick={() => handleReply(message.id)} className="bg-indigo-600 text-white p-2 rounded-lg active:scale-95 transition-transform" data-id="element-456">
                        <SendIcon size={18} data-id="element-457" />
                      </button>
                    </div>
                  </div>}
              </div>)}
          </div>
        </div>
        <div data-id="element-458">
          <div className="flex items-center mb-3" data-id="element-459">
            <UsersIcon size={20} className="text-rose-600 mr-2" data-id="element-460" />
            <h2 className="text-lg font-bold text-gray-800" data-id="element-461">社区消息</h2>
          </div>
          <div className="space-y-3" data-id="element-462">
            {communityMessages.map(message => <div key={message.id} className={`bg-white rounded-xl shadow-md overflow-hidden ${!message.isRead ? 'border-2 border-rose-200' : ''}`} data-id="element-463">
                <div className="p-4 cursor-pointer active:bg-gray-50" onClick={() => toggleMessage(message.id)} data-id="element-464">
                  <div className="flex items-start gap-3" data-id="element-465">
                    <img src={message.sender.avatar} alt={message.sender.name} className="w-12 h-12 rounded-full object-cover" data-id="element-466" />
                    <div className="flex-1" data-id="element-467">
                      <div className="flex items-center justify-between mb-1" data-id="element-468">
                        <h3 className="font-semibold text-gray-800" data-id="element-469">
                          {message.sender.name}
                        </h3>
                        <span className="text-xs text-gray-500" data-id="element-470">
                          {message.time}
                        </span>
                      </div>
                      <p className="text-sm text-gray-700 line-clamp-2" data-id="element-471">
                        {message.content}
                      </p>
                    </div>
                  </div>
                </div>
                {expandedMessage === message.id && <div className="border-t border-gray-100 bg-gray-50 p-4" data-id="element-472">
                    <p className="text-sm text-gray-700 mb-4" data-id="element-473">
                      {message.content}
                    </p>
                    {message.replies && message.replies.length > 0 && <div className="space-y-3 mb-4" data-id="element-474">
                        {message.replies.map(reply => <div key={reply.id} className="bg-white rounded-lg p-3" data-id="element-475">
                            <div className="flex items-center justify-between mb-2" data-id="element-476">
                              <span className="text-sm font-medium text-gray-800" data-id="element-477">
                                {reply.sender}
                              </span>
                              <span className="text-xs text-gray-500" data-id="element-478">
                                {reply.time}
                              </span>
                            </div>
                            <p className="text-sm text-gray-700" data-id="element-479">
                              {reply.content}
                            </p>
                          </div>)}
                      </div>}
                    <div className="flex gap-2" data-id="element-480">
                      <input type="text" value={replyText[message.id] || ''} onChange={e => setReplyText({
                  ...replyText,
                  [message.id]: e.target.value
                })} placeholder="输入回复..." className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-481" />
                      <button onClick={() => handleReply(message.id)} className="bg-rose-600 text-white p-2 rounded-lg active:scale-95 transition-transform" data-id="element-482">
                        <SendIcon size={18} data-id="element-483" />
                      </button>
                    </div>
                  </div>}
              </div>)}
          </div>
        </div>
      </main>
      <BottomNav data-id="element-484" />
    </div>;
}